import SentenceClass from 'utils/SentenceClass'
var _ = require('underscore');

class SentenceBuilder {
  constructor(end, start, introText, bodyText){
    this.end = end;
    this.start = start;
    this.introText = introText;
    this.bodyText = bodyText;
  }

  splitSentence(text) {
    return text.match( /([^\.!\?]+[\.!\?]+|[^\.!\?]+$|^$|[\.!\?]+)/g);
  }

  // extraBoundaries (optional): absolute character offsets at which to cut the
  // body text IN ADDITION to the excerpts' own boundaries. The comparison page
  // passes the diff-segment edges (the union of both coders' excerpt
  // boundaries) so every rendered span falls entirely inside one diff segment
  // and can be recolored exactly (see buildUnderlineSpans in codeDiffUtils).
  // When absent or empty — every other caller — this is a no-op and the
  // output is identical to before the parameter existed.
  constructSentences(excerpts, extraBoundaries = []) {
    // Split the body text up with the text before, inside, and after the first excerpt, put it in an array
    const introLength = this.introText ? this.introText.length : 0;

    let bodyTextArray = [{
      start: 0,
      end: this.end - this.start - introLength,
      text: this.bodyText,
      type: 'text'
    }]

    // Sort Excerpt by start, and filter out the ones that do not have memos or codings

    excerpts = excerpts.sort((a, b) => {
      if ( a.start < b.start ) return -1;
      if ( a.start > b.start ) return 1;
      if ( a.end > b.end ) return -1;
      if ( a.end < b.end ) return 1;
      return 0;
    }).filter(
      (excerpt) => 
        (excerpt.memos || []).length > 0 || 
        (excerpt.codings || []).length > 0
    );
    
    for ( var i = 0; i < excerpts.length; i++ ) {
      const excerpt = excerpts[i];
      const bodyExcerptStart = excerpt.start - introLength - this.start;
      const bodyExcerptEnd = excerpt.end - introLength - this.start;

      bodyTextArray = _.flatten(
        bodyTextArray.map(
          (bodyTextElement) => {
            
            const fullyOutsideBodyText = bodyExcerptStart >= bodyTextElement.end || bodyExcerptEnd <= bodyTextElement.start;
            if ( fullyOutsideBodyText ) return bodyTextElement;

            const excerptStart = Math.max(bodyExcerptStart, bodyTextElement.start);
            const excerptEnd = Math.min(bodyExcerptEnd, bodyTextElement.end);

            const codeIds = (excerpt?.codings || []).map(coding => coding.code_id);

            return [
              {
                start: bodyTextElement.start,
                end: excerptStart,
                text: bodyTextElement.text.slice(
                  0,
                  excerptStart - bodyTextElement.start),
                type: bodyTextElement.type,
                excerptIds: bodyTextElement.excerptIds,
                excerptId: bodyTextElement.excerptId,
                codeIds
              },
              {
                start: excerptStart,
                end: excerptEnd,
                text: bodyTextElement.text.slice(
                  excerptStart - bodyTextElement.start,
                  excerptEnd - bodyTextElement.start
                ),
                excerptId: excerpt.id || bodyTextElement.excerptId,
                excerptIds: (bodyTextElement.excerptIds || []).concat([excerpt.id]).filter((id) => !!id),
                codeIds,
                type: 'excerpt'
              },
              {
                start: excerptEnd,
                end: bodyTextElement.end,
                text: bodyTextElement.text.slice(bodyExcerptEnd - bodyTextElement.start),
                type: bodyTextElement.type,
                excerptId: bodyTextElement.excerptId,
                excerptIds: bodyTextElement.excerptIds,
                codeIds
              }
            ].filter((bodyTextElement) => bodyTextElement.start !== bodyTextElement.end)
        })
      );
    }

    // Cut every element again at each extra boundary that falls strictly
    // inside it. Both halves keep the element's type/excerptId/excerptIds/
    // codeIds, so a long excerpt chunk simply renders as several spans of the
    // same excerpt — hover/click identity is untouched, only the span
    // granularity changes.
    const bodyLength = this.end - this.start - introLength;
    (extraBoundaries || [])
      .map((boundary) => boundary - this.start - introLength)
      .filter((boundary) => boundary > 0 && boundary < bodyLength)
      .forEach((boundary) => {
        bodyTextArray = _.flatten(
          bodyTextArray.map((bodyTextElement) => {
            if (boundary <= bodyTextElement.start || boundary >= bodyTextElement.end) return bodyTextElement;
            return [
              {
                ...bodyTextElement,
                end: boundary,
                text: bodyTextElement.text.slice(0, boundary - bodyTextElement.start)
              },
              {
                ...bodyTextElement,
                start: boundary,
                text: bodyTextElement.text.slice(boundary - bodyTextElement.start)
              }
            ];
          })
        );
      });

    // apply split sentences to each of the body text array elements
    return _.chain(bodyTextArray).map((bodyTextElement) => {
      if ( bodyTextElement.type === 'excerpt' ) return bodyTextElement;

      const splitSentences = this.splitSentence(bodyTextElement.text);
      const splitSentencesWithStartAndEnd = splitSentences.map((sentence, index) => {
        const start = index === 0 ? bodyTextElement.start : bodyTextElement.start + splitSentences.slice(0, index).join('').length;
        const end = start + sentence.length;
        return {
          start,
          end,
          text: sentence,
          type: 'text'
        }
      })

      return splitSentencesWithStartAndEnd;
    }).flatten().map(((bodyTextElement) => {
      return new SentenceClass(
        bodyTextElement.text, 
        bodyTextElement.start + this.start + introLength, 
        bodyTextElement.excerptId, 
        bodyTextElement.excerptIds,
      );
    })).value();
  }
}

export default SentenceBuilder;
